import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Grid,
} from '@mui/material';
import { Title, useTranslate } from 'react-admin';
import BadgeGrid from './BadgeGrid';
import StreakDisplay from './StreakDisplay';

const MyAchievements: React.FC = () => {
    const translate = useTranslate();

    return (
        <Box>
            <Title title={translate('gamification.achievements')} />

            <Grid container spacing={3}>
                {/* Streak Section */}
                <Grid size={12}>
                    <Paper sx={{ p: 2 }}>
                        <Typography variant="h6" gutterBottom>
                            {translate('gamification.streakTitle')}
                        </Typography>
                        <StreakDisplay />
                    </Paper>
                </Grid>

                {/* Badges Section */}
                <Grid size={12}>
                    <Paper sx={{ p: 2 }}>
                        <BadgeGrid
                            showTabs
                            title={translate('gamification.badgesTitle')}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default MyAchievements;
